import CrescentLogo from 'resources/svgs/crescent_logo.svg';

const AppLogo = () => {
  return <img src={CrescentLogo} alt="Crescent Logo" className="min-w-fit" />;
};

export default AppLogo;
